let recaptchaLoaded = false;
let loadingPromise = null;

const SITE_KEY = '6LefKMUsAAAAAKCU_DcgwRnSCKwCH6waYB90GF3V';

export const loadRecaptcha = () => {
  if (recaptchaLoaded) {
    return Promise.resolve();
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      recaptchaLoaded = true;
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      recaptchaLoaded = true;
      resolve();
    };
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.head.appendChild(script);
  });

  return loadingPromise;
};

export const getRecaptchaToken = async (action = 'submit') => {
  try {
    await loadRecaptcha();
    
    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(SITE_KEY, { action });
          resolve(token);
        } catch (error) {
          reject(error);
        }
      });
    });
  } catch (error) {
    console.error('reCAPTCHA error:', error);
    return null;
  }
};